import React from "react";
import { Button, Container, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

import image from "assets/img/team.png";

const Careers = () => {
  return (
    <>
      <div className="main">
        <div className="section section-maglev-blue text-center">
          <Container>
            <Row className="align-items-center">
              <Col xs={12} md={12} lg={6} className="text-center">
                <h1 className="title text-lg-left" style={{fontWeight: 'bolder'}}>Join the Team</h1>
                <p className="text-center text-lg-left" style={{ fontSize: '1.25em', color: 'white', textAlign: 'left', paddingBottom: '20px' }}>
                  Our employees are the driving force behind our success and their
                  unwavering passion is what sets us apart. We're proud to have a team
                  of individuals who are not just skilled and experienced but deeply
                  passionate about the work they do. Together we are shaping a future 
                  where transportation is not just efficient, but sustainable, safe, and exciting.
                </p>
                <Button
                  href="https://careers.smartrecruiters.com/MaglevAeroInc"
                  className="btn-round mr-1"
                  color="neutral"
                  outline
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{marginBottom:"30px"}}
                >
                  Apply Here&nbsp;&nbsp;<FontAwesomeIcon icon={faExternalLink}/>
                </Button>
              </Col>
              <Col xs={12} md={12} lg={6} className="text-center mb-4 mb-md-0">
                <img
                  src={image}
                  alt="Team"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    borderRadius: '10px',
                    maxHeight: '300px', // Set a max height to control the image size
                    margin: 'auto', // Center the image horizontally
                    display: 'block', // Ensure block-level display
                  }}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Careers;
